import type { FC } from 'react';

import { CloseIcon, OpenIcon } from './styles';
import type { IconProps } from './types';

export const Icon: FC<IconProps> = ({ isChatOpened }) => (isChatOpened ? <CloseIcon /> : <OpenIcon />);
